import { tagsSort } from './tools';

// eslint-disable-next-line
export let flatTagsById = {};
// eslint-disable-next-line
export let rootTagsByGames = {};

function childTags(tags, tag) {
  return tags.filter((t) => t.parent_id === tag.id);
}

function fillTag(tags, tag, parentBranch) {
  const children = childTags(tags, tag);
  const tagBranch = { ...tag };

  if (children.length) {
    tagBranch._children = [];
    children.forEach((child) => {
      tagBranch._children.push(fillTag(tags, child, tagBranch));
    });
  }

  if (parentBranch) {
    tagBranch._parent = parentBranch;
  }

  return tagBranch;
}

export function setFlatTagsById(tags) {
  flatTagsById = {};
  // копируем чтобы не нарушить порядок оригинального tags
  [...tags]
    .sort((a, b) => {
      if (a.parent_id === null) {
        return -1;
      }

      if (a.id < b.id) {
        return -1;
      }

      return 1;
    }).forEach((tag) => {
      if (tag.parent_id) {
        flatTagsById[tag.id] = fillTag(tags, tag, flatTagsById[tag.parent_id]);
      } else {
        flatTagsById[tag.id] = fillTag(tags, tag);
      }
    });
}

export function setRootTagsByGames() {
  rootTagsByGames = {};

  Object.values(flatTagsById).sort(tagsSort)
    .forEach((tag) => {
      if (!rootTagsByGames[tag.game_id]) {
        rootTagsByGames[tag.game_id] = [];
      }

      if (tag.is_sidebar && !tag.parent_id) {
        if (tag._children) {
          const children = [];

          tag._children.forEach((child) => {
            if (child.is_sidebar) {
              children.push(child);
            }
          });

          tag._children = children;

          if (tag._children.length === 0) {
            delete tag._children;
          }
        }

        rootTagsByGames[tag.game_id].push(tag);
      }
    });
}
